import React, { useState } from "react";
import { Box, Typography, Button, IconButton, Dialog, DialogTitle, DialogContent, DialogActions, TextField, MenuItem, Select, FormControl, InputLabel, CircularProgress } from "@mui/material";
import { Close as CloseIcon } from "@mui/icons-material";
import config from "../config.json";
import { uploadImageToR2 } from "../functions/r2BulkUpload";

async function uploadToR2(file) {
  return uploadImageToR2(file, "blog");
}

export default function BlogEditorModal({ open, isEditing, formData, setFormData, onClose, onSave, themeConfig }) {
  const [uploading, setUploading] = useState(false);

  const handleImageFilesSelected = async (e) => {
    const files = Array.from(e.target.files);
    if (!files.length) return;
    setUploading(true);
    try {
      const uploadedUrls = await Promise.all(files.map(uploadToR2));
      setFormData((prev) => ({ ...prev, images: [...prev.images, ...uploadedUrls] }));
    } catch (err) {
      alert("Image upload failed. Please try again.");
    } finally {
      setUploading(false);
    }
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle style={{ fontFamily: "'Raleway', sans-serif", fontWeight: 800 }}>
        {isEditing ? "Edit Story" : "Create New Story"}
      </DialogTitle>
      <DialogContent dividers>
        <TextField label="Title" fullWidth margin="dense" value={formData.title} onChange={(e) => setFormData({ ...formData, title: e.target.value })} />
        <TextField label="Summary / Snippet" fullWidth margin="dense" value={formData.snippet} onChange={(e) => setFormData({ ...formData, snippet: e.target.value })} />
        <TextField label="Full Content" fullWidth multiline rows={6} margin="dense" value={formData.content} onChange={(e) => setFormData({ ...formData, content: e.target.value })} />
        <FormControl fullWidth margin="dense">
          <InputLabel id="domain-label">Domain Visibility</InputLabel>
          <Select labelId="domain-label" value={formData.domain} label="Domain Visibility" onChange={(e) => setFormData({ ...formData, domain: e.target.value })}>
            <MenuItem value="all">All Sites (Cross-site)</MenuItem>
            {Object.keys(config || {}).map((brandKey) => (
              <MenuItem key={brandKey} value={brandKey}>{brandKey}</MenuItem>
            ))}
          </Select>
        </FormControl>
        <Box mt={2}>
          <Typography variant="subtitle2" style={{ fontWeight: 700, marginBottom: "8px" }}>Photos</Typography>
          <input type="file" multiple accept="image/*" onChange={handleImageFilesSelected} disabled={uploading} />
          {uploading && <CircularProgress size={20} style={{ marginLeft: "10px" }} />}
          {formData.images.length > 0 && (
            <Box display="flex" gap={1} mt={1} flexWrap="wrap">
              {formData.images.map((url, idx) => (
                <Box key={idx} style={{ position: "relative" }}>
                  <img src={url} alt={`upload-${idx}`} style={{ width: 60, height: 60, objectFit: "cover", borderRadius: "6px" }} />
                  <IconButton size="small" onClick={() => setFormData({ ...formData, images: formData.images.filter((_, i) => i !== idx) })} style={{ position: "absolute", top: -8, right: -8, backgroundColor: "#fff", padding: 2 }}><CloseIcon fontSize="inherit" /></IconButton>
                </Box>
              ))}
            </Box>
          )}
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} style={{ textTransform: "none" }}>Cancel</Button>
        <Button variant="contained" onClick={onSave} disabled={uploading} style={{ backgroundColor: themeConfig.buttonColor, color: themeConfig.buttonFontColor, textTransform: "none", fontWeight: 700 }}>
          Save Story
        </Button>
      </DialogActions>
    </Dialog>
  );
}
